import React from 'react'
import { Link } from 'react-router-dom'
import { LOGO, LOGO_WHITE } from '../../../../Utils'
import { NavLink, useLocation, useHistory } from 'react-router-dom'
import './RegistrationLayout.css'
const RegistrationLayout = (props) => {
    const location = useLocation()
    return (
        <div className="logRegLayout">
            {!props?.moreStep && (
                <div className="leftImgContainer">
                    <div className="logoContainer">
                        {/* <img className="whtBackDrop" src="/assets/svg/whitevector.svg" /> */}
                        {location.pathname == '/register' ||
                        location.pathname == '/registration' ? (
                            localStorage.ttw_temp_user_id ? (
                                <a onClick={() => props.cancelTemp()}>
                                    <img src={LOGO_WHITE} className="mnLogo cursorDecoy" />
                                </a>
                            ) : (
                                <a href={`${process.env.REACT_APP_FRONTEND_URL}`}>
                                    <img src={LOGO_WHITE} className="mnLogo cursorDecoy" />
                                </a>
                            )
                        ) : location.pathname == '/login' ? (
                            <a href={`${process.env.REACT_APP_FRONTEND_URL}`}>
                                <img src={LOGO_WHITE} className="mnLogo cursorDecoy" />
                            </a>
                        ) : (
                            <a href="https://songvest.com">
                                <img src={LOGO_WHITE} className="mnLogo cursorDecoy" />
                            </a>
                        )}
                    </div>
                    {/* <img className="vrtclogo" src="/assets/images/vertical_logos.png" /> */}
                    <div className="logRegisterContentCnt">
                        {props?.activeStep === 0 && (
                            <>
                                <div>
                                    <h2> What is SongVest</h2>
                                    <p>
                                        Songvest unlocks the opportunity for fans to invest in the
                                        artists they love through SongShares®, our fractional
                                        royalty securities. Our trusted and secure platform has
                                        generated over $25 million for artists, whilst allowing fans
                                        a deeper musical connection. Join over 25,000 music
                                        investors along with artists such as TLC, Queen, Beyonce,
                                        Young Thug & more!
                                    </p>
                                </div>
                                <div>
                                    <h2> Getting Started </h2>
                                    <p>
                                        To get started with SongVest, complete the form to create an
                                        account.
                                    </p>
                                </div>
                            </>
                        )}

                        {!(props?.activeStep === 0) && (
                            <>
                                <div>
                                    <h2> Setting Up Tour Account</h2>
                                    <p>
                                        {`To ensure you're eligible to purchase on SongVest, we're
                                        required by U.S. regulations and the SEC to collect certain
                                        personal information. This helps us comply with identity
                                        verification requirements and keeps our platform secure.`}
                                    </p>
                                </div>
                                <div>
                                    <h2>Why We Need Your Personal Information?</h2>
                                    <p>
                                        <strong>User Type:</strong>
                                        &nbsp;Allows you to register as an individual or corporate
                                        entity.
                                    </p>
                                    <p>
                                        <strong>Domicile:</strong>
                                        &nbsp;To comply with required laws around purchase, which
                                        may vary by jurisdiction.
                                    </p>
                                    <p>
                                        <strong>Date of Birth:</strong>
                                        &nbsp;To verify you are eligible to invest.
                                    </p>
                                    <p>
                                        <strong>SSN:</strong>
                                        &nbsp;If you have a SSN, we are required to capture this per
                                        SEC regulations. This data is stored in an encrypted format
                                        and can’t be viewed by anyone at SongVest.
                                    </p>
                                    <p>
                                        <strong>Address:</strong>
                                        &nbsp;To help verify your identity and eligibility to
                                        invest. Make sure this matches the address on your current
                                        ID.
                                    </p>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

            {console.log(props, 'props1234')}
            <div className="rtDtlContainer w-100">{props.children}</div>
        </div>
    )
}

export default RegistrationLayout
